import get from 'lodash-es/get'
import { IEnhancedLocation } from '../reducers/reactRouterLocation'
import { getTopLevelRoute } from './urlHelper'

const searchPagePaths = ['search', 'category', 'tags', 'attributes']

export const isSearchPageLocation = (url: string): boolean => {
  const pageName = getTopLevelRoute(url)
  return searchPagePaths.includes(pageName)
}

export const isHomePageLocation = (url: string): boolean => {
  return url === '/'
}

export const isSimilarItemsPageLocation = (
  location: IEnhancedLocation | null
): boolean => {
  return (
    isSearchPageLocation(get(location, 'pathname', '')) &&
    !!get(location, 'query.item_id', false)
  )
}
